import { render, staticRenderFns } from "./vipTan.vue?vue&type=template&id=45b20482&scoped=true"
import script from "./vipTan.vue?vue&type=script&lang=js"
export * from "./vipTan.vue?vue&type=script&lang=js"
import style0 from "./vipTan.vue?vue&type=style&index=0&id=45b20482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b20482",
  null
  
)

export default component.exports